import React, { useState } from "react";
import { View, Text, TouchableOpacity } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { FontFamilies } from "@/constants/Typography";

const SpendOption = ({
  label,
  onPress,
  isSelected,
}: {
  label: string;
  onPress: () => void;
  isSelected: boolean;
}) => (
  <TouchableOpacity
    style={[styles.option, isSelected && styles.selectedOption]}
    onPress={onPress}
  >
    <Text style={styles.optionText}>{label}</Text>
  </TouchableOpacity>
);

const OnboardSlide12 = () => {
  const [selectedOption, setSelectedOption] = useState<number>();
  return (
    <View style={styles.container}>
      <Text style={styles.title}>
        How much are you spending on subscriptions every month?
      </Text>
      <Text style={styles.subtitle}>Example: forgot to cancel free trial</Text>
      <View style={styles.options}>
        <SpendOption
          label="Less than $50/month"
          onPress={() => setSelectedOption(0)}
          isSelected={selectedOption === 0}
        />
        <SpendOption
          label="Over $50 per month"
          onPress={() => setSelectedOption(1)}
          isSelected={selectedOption === 1}
        />
        <SpendOption
          label="Not sure"
          onPress={() => setSelectedOption(2)}
          isSelected={selectedOption === 2}
        />
      </View>
    </View>
  );
};

export default OnboardSlide12;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingTop: 32,
    gap: 16,
  },
  title: {
    fontFamily: FontFamilies.InterTight.SemiBold,
    fontSize: 32,
    lineHeight: 38,
    color: "#EBFFEE",
  },
  subtitle: {
    fontFamily: FontFamilies.Inter.Regular,
    fontSize: 16,
    color: "#EBFFEE",
    opacity: 0.7,
  },
  options: {
    width: "100%",
    gap: 12,
  },
  option: {
    backgroundColor: "white",
    borderRadius: 12,
    height: 56,
    justifyContent: "center",
    alignItems: "center",
    borderWidth: 1,
    borderColor: "#02685B",
  },
  selectedOption: {
    borderColor: "#CBEB6C",
    backgroundColor: "#E1EFE4",
  },
  optionText: {
    fontFamily: FontFamilies.InterTight.SemiBold,
    fontSize: 18,
    color: "#161D14",
  },
});
